import { Box, useColorMode } from '@chakra-ui/react';
import { Outlet } from 'react-router-dom';
import Sidebar from '../Components/Sidebar/Sidebar';
import routes from '../routes';
import bgAdmin from '../Assests/Img/admin-background.png';
import MainPanel from '../Components/Layouts/MainPanel';
import AdminNavbar from '../Components/Navbars/AdminNavbar';
import ContentPanel from '../Components/Layouts/ContentPanel';

const AdminLayout = () => {
  const { colorMode } = useColorMode();
  return (
    <Box>
      <Box
        minH="40vh"
        w="100%"
        position="absolute"
        bgImage={colorMode === 'light' ? bgAdmin : 'none'}
        bg={colorMode === 'light' ? bgAdmin : 'navy.900'}
        bgSize="cover"
        top="0"
      />
      <Sidebar routes={routes} />
      <MainPanel>
        <AdminNavbar />
        <ContentPanel>
          <Outlet />
        </ContentPanel>
      </MainPanel>
    </Box>
  );
};
export default AdminLayout;
